import { Component, Input, OnInit, Output, EventEmitter, inject } from "@angular/core";
import { MessageService } from "primeng/api";
import { DocumentService } from "src/app/services/document.service";
import { ILogger, LOGGER_TOKEN } from 'src/app/services/logger/ilogger';

@Component({
  selector: "app-browse-documents",
  templateUrl: "./browse-documents.component.html",
  styleUrls: ["./browse-documents.component.css"],
  standalone: false,
})
export class BrowseDocumentsComponent implements OnInit {
  private readonly logger = inject<ILogger>(LOGGER_TOKEN);
  documentService = inject(DocumentService);
  private messageService = inject(MessageService);

  @Input() record: any;

  documents: any = null;
  isDownloading = false;
  @Output() valueChange = new EventEmitter();
  ngOnInit(): void {
    const adminId = typeof this.record.adminId === "undefined" ? this.record.lanId : this.record.adminId;

    let recordId = "none";
    if (typeof this.record.totalVariance === "undefined")
      recordId = this.record["id"];
    this.documents = [];
    if (![null, undefined, ""].includes(adminId))
      this.documentService.fetchFiles(adminId, recordId).subscribe({
        next: (data) => {
          this.documents = data;
          this.documents.forEach((doc: any)=>{
            doc['niceName'] = doc.fileName.split('.')[0]
            if(!doc.notes || doc.notes == 'undefined'){
              doc['notes'] = ''
            }
          })
        },
        error: (err) => { 
          this.logger.error('Error fetching files:', { error: err });
        }
      });
  }

  downloadDocument(document: any) {
    document.isDownloading = true;
    const fileName = document._id + "." + document.ext;
    this.documentService.downloadDocument(fileName).subscribe({
      next: (res) => {
        this.isDownloading = false;
        document.isDownloading = false;
        this.downLoadFile(res, document.fileName.replace(".enc", ""), document.ext ? document.ext : 'application/octet-stream');
        this.messageService.add({
          severity: "success",
          summary: "Document Download",
          detail: "Document downloaded successfully.",
        });
      },
      error: () => {
        this.messageService.add({
          severity: "error",
          summary: "Document Download",
          detail: "Document download failed.",
        });
        document.isDownloading = false;
      }
    });
  }

  getMimeType(extension: string): string {
    const mimeTypes = {
      'png': 'image/png',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'gif': 'image/gif',
      'pdf': 'application/pdf',
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'txt': 'text/plain',
      'csv': 'text/csv',
      'zip': 'application/zip',
      'mp4': 'video/mp4',
      'mp3': 'audio/mpeg'
    };
    return (mimeTypes as any)[extension.toLowerCase()] || 'application/octet-stream';
  }

  downLoadFile(data: any, filename: any, extension: string) {
    const mimeType = this.getMimeType(extension);
    const blob = new Blob([data], { type: mimeType });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    document.body.appendChild(anchor);
    anchor.download = filename;
    (anchor.attributes as any)["style"] = "display: none;";
    anchor.href = url;
    anchor.click();
  }

  deleteDocument(record: any) {
    if (confirm("Are you sure that you want to Delete this?")){
      this.documentService.deleteDocument(record._id).subscribe({
        next: (res) => {
          if ((res as any)["deleted"] == true) {
            this.valueChange.emit(1);
            this.messageService.add({
              severity: "success",
              summary: "Message",
              detail: "File delted successfully.",
            });
            this.documents = this.documents.filter(
              (document: any) => document._id !== record._id
            );
            return;
          }
          this.messageService.add({
            severity: "error",
            summary: "Message",
            detail: "Failed to delte the file.",
          });
        },
        error: () => {
          this.messageService.add({
            severity: "error",
            summary: "Message",
            detail: "Failed to delte the file.",
          });
        }
      });
    }
  }
}
